import React from "react";
import { useNavigate } from "react-router-dom";
import "./List.css";

function Item({ item }) {
  const navigate = useNavigate();
  return (
    <div
      className={
        item.useContinuity && !item.enabled
          ? "listItemDeactivated"
          : "listItemEnabled"
      }
      onClick={() => {
        if (item.useContinuity && !item.enabled) {
          return;
        } else {
          navigate(item.navigateTo, { state: item.route });
        }
      }}
    >
      <li
        style={{
          color: "white",
        }}
      >
        {item.value}
      </li>
    </div>
  );
}

function List({ data, height }) {
  return (
    <div
      style={{
        backgroundColor: "#F27059",
        overflowY: "auto",
        height,
        margin: "10px",
        borderRadius: "8px",
      }}
    >
      <ul
        style={{
          listStyle: "none",
          padding: "0px",
        }}
      >
        {data.map((item) => (
          <Item key={item.key} item={item} />
        ))}
      </ul>
    </div>
  );
}

export default List;
